import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { PageTitleService } from '../../../../Utils/_services/page-title/page-title.service';
import { FormsModule, NgModel } from '@angular/forms';
import { ToastrService, ToastrModule } from 'ngx-toastr';
import { ICustomError } from '../../../../Utils/_models/network-response';
import { AdminNavDetailsComponent } from "../../layout/admin-nav-details/admin-nav-details.component";
import { JoinAppWaitlistService } from '../../../../Utils/_services/join-app-waitlist/join-app-waitlist.service';
import { IJoinAppWaitlist_Request, IJoinAppWaitlist_Response } from '../../../../Utils/_services/join-app-waitlist/join-app-waitlist.model';
import { PhonePipe } from '../../../../Utils/_pipes/phone.pipe';


@Component({
  selector: 'app-join-app-waitlist',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ToastrModule,
    AdminNavDetailsComponent,
    PhonePipe
  ],
  templateUrl: "./join-app-waitlist.component.html",
  styleUrl: "./join-app-waitlist.component.css"
})
export class JoinAppWaitlistComponent {

  // properties
  viewMode: 'card' | 'table' = 'table';
  showModal = false;
  selectetWaitlist: IJoinAppWaitlist_Response | null = null;
  joinAppWaitlists: IJoinAppWaitlist_Response[] = [];
  pageNumber = 1;
  pageSize = 5;
  totalItems = 0;
  totalPages = 0;
  isLoading = false;
  isSubmitting = false;

  constructor(
    private pageTitle: PageTitleService,
    private joinAppWaitlistService: JoinAppWaitlistService,
    private toastr: ToastrService
  ) { }

  ngOnInit(): void {
    this.pageTitle.setTitle('Join Waitlist');
    this.loadJoinAppWaitlist();
  }

  loadJoinAppWaitlist() {
    this.isLoading = true;
    this.joinAppWaitlistService.getAll(this.pageNumber, this.pageSize).subscribe({
      next: (result) => {
        console.log("What is result - ", result);
        this.joinAppWaitlists = result.data.items;
        this.totalItems = result.data.totalCount;
        this.totalPages = Math.ceil(this.totalItems / this.pageSize);
        this.isLoading = false;
      },
      error: (err: ICustomError) => {
        this.isLoading = false;
        console.error('Failed to load bugs:', err.error.msg);
        this.toastr.error('Error loading app waitlist. Please try again.', 'Error');
      }
    });
  }

  updateBug() {
    if (this.selectetWaitlist && this.selectetWaitlist.id) {
      this.isSubmitting = true;
      console.log("Wht is this.selectetWaitlist - ", this.selectetWaitlist);
      this.joinAppWaitlistService.update(this.selectetWaitlist.id, this.selectetWaitlist).subscribe({
        next: () => {
          this.isSubmitting = false;
          this.toastr.info('Bug updated successfully!', 'Success');
          this.loadJoinAppWaitlist();
          this.closeModal();
        },
        error: (err) => {
          this.isSubmitting = false;
          console.error('Failed to update bug:', err);
          this.toastr.error(err.error?.message || 'Failed to update bug. Please try again.', 'Error');
        }
      });
    }
  }

  toggleView() {
    this.viewMode = this.viewMode === 'card' ? 'table' : 'card';
  }

  viewBug(bug: IJoinAppWaitlist_Response) {
    this.selectetWaitlist = { ...bug, leadSource: String(bug.leadSource) as any, id: String(bug.id), };
    this.showModal = true;
  }

  closeModal() {
    this.showModal = false;
    this.selectetWaitlist = null;
  }

  // updateBug() {
  //   if (this.selectetWaitlist) {
  //     const index = this.bugs.findIndex(b => b.id === this.selectetWaitlist!.id);
  //     if (index !== -1) {
  //       this.bugs[index] = { ...this.selectetWaitlist };
  //     }
  //     this.closeModal();
  //   }
  // }

  changePage(page: number) {
    if (page >= 1 && page <= this.totalPages) {
      this.pageNumber = page;
      this.loadJoinAppWaitlist();
    }
  }

  getVisiblePages(): number[] {
    const visiblePages: number[] = [];
    const maxVisiblePages = 5;

    if (this.totalPages <= maxVisiblePages) {
      // Show all pages if total pages is small (excluding first and last as they're handled separately)
      for (let i = 2; i < this.totalPages; i++) {
        visiblePages.push(i);
      }
    } else {
      // Show pages around current page
      let startPage = Math.max(2, this.pageNumber - 1);
      let endPage = Math.min(this.totalPages - 1, this.pageNumber + 1);

      // Ensure we don't include first and last page (they're handled separately)
      for (let i = startPage; i <= endPage; i++) {
        if (i > 1 && i < this.totalPages) {
          visiblePages.push(i);
        }
      }
    }

    return visiblePages;
  }

  getPreferedContactMethodClass(status: number): string {
    const preferredContactMethod = status.toString().toLowerCase();
    switch (preferredContactMethod) {
      case '0': return 'status-open';
      case '1': return 'status-progress';
      case '2': return 'status-pending';
      case '3': return 'status-closed';
      default: return '';
    }
  }

  getLeadSourceClass(priority: number): string {
    const leadSource = priority.toString().toLowerCase();
    switch (leadSource) {
      case '0': return 'priority-high';
      case '1': return 'priority-medium';
      case '2': return 'priority-low';
      default: return '';
    }
  }
}
